import styled from 'styled-components'
import BaseModal from '../../../lib/modals/Modal'
import { ButtonIcon, Button, tokens } from '@arvoreeducacao/bonsai-ds'

export const Modal = styled(BaseModal)`
  width: 400px;
  border-radius: ${tokens.radius.xlarge};
  padding: ${tokens.spacing.insetSmall};
`

export const EntityArea = styled.div`
  height: 310px;
  margin: 16px 0px;
  border: 1px solid ${tokens.colors.dark2};
  box-sizing: border-box;
  border-radius: ${tokens.radius.large};
  overflow: auto;
`

interface ParentEntityProps {
  hasOpenedChildren: boolean
  isSelected: boolean
}

export const ParentEntity = styled.div<ParentEntityProps>`
  padding: ${tokens.spacing.insetMedium};
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  color: ${({ isSelected }) =>
    isSelected ? tokens.colors.dark6 : tokens.colors.dark5};
  ${({ hasOpenedChildren, isSelected }) =>
    (hasOpenedChildren || isSelected) &&
    `font-weight: ${tokens.fontWeights.bold};`}
`

export const BreakLine = styled.hr<{ isBold: boolean }>`
  width: 100%;
  margin: 0;
  border-top: 1px solid
    ${({ isBold }) => (isBold ? tokens.colors.dark2 : tokens.colors.dark1)};
`

export const ChildEntity = styled.div<{ isSelected: boolean }>`
  padding: ${tokens.spacing.insetMedium};
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  color: ${({ isSelected }) =>
    isSelected ? tokens.colors.dark6 : tokens.colors.dark5};
  font-weight: ${({ isSelected }) =>
    isSelected ? tokens.fontWeights.bold : tokens.fontWeights.regular};
`

export const BackArrowButton = styled(ButtonIcon)`
  margin-right: ${tokens.spacing.horizontalMedium};
`

export const RightArrowButton = styled(ButtonIcon)`
  margin-left: auto;
`

export const RightButton = styled(Button)`
  margin-left: auto;
`
